 
 
import {
  clearSaveMaintenance,
  saveMaintenanceFail,
  saveMaintenanceStarted,
  saveMaintenanceSuccess
} from '../../../reducer/schedule-maintenance/SaveMaintenanceReducer';
import { saveMaintenance } from '../../actionType/schedule-maintenance/SaveMaintenanceTypes';
import {
  ClearSaveMaintenance,
  SaveMaintenanceFailure,
  SaveMaintenanceFailurePayload,
  SaveMaintenanceRequest,
  SaveMaintenanceStarted,
  SaveMaintenanceSuccess,
  SaveMaintenanceSuccessPayload
} from '../../types/schedule-maintenance/SaveMaintenanceTypes';

export const saveMaintenanceRequest = (
  reqObject: any
): SaveMaintenanceRequest => ({
  type: saveMaintenance.SAVE_MAINTENANCE_REQUEST,
  requestObject: reqObject
});

/**
 * get metric summary started saga action
 * @returns get metric summary action
 */
export const saveMaintenanceStart =
  (): SaveMaintenanceStarted => ({
    type: saveMaintenanceStarted.type
  });

/**
 * Get metric summary success saga action
 * @param payload :Metric data
 * @returns success action
 */
export const saveMaintenanceSuccessful = (
  payload: SaveMaintenanceSuccessPayload
): SaveMaintenanceSuccess => ({
  type: saveMaintenanceSuccess.type,
  payload
});

/**
 * get metric Failed saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const saveMaintenanceFailure = (
  payload: SaveMaintenanceFailurePayload
): SaveMaintenanceFailure => ({
  type: saveMaintenanceFail.type,
  payload
});

/**
 * Clear metrics saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const clearsaveMaintenance =
  (): ClearSaveMaintenance => ({
    type: clearSaveMaintenance.type
  });
